<template>
    <div>
        <div v-if="editMode" class="row form-group col-12 pr-0">
            <div class="col-8">
                <label for="number">Number</label>
                <input
                    id="number"
                    v-model="course.number"
                    type="text"
                    class="form-control"
                    dir="auto"
                    disabled
                />
            </div>

            <div class="col-4">
                <label for="number">Actual status</label>
                <b-badge
                    pill
                    class="form-control d-flex align-items-center justify-content-center"
                    variant="success"
                >
                    {{ status }}
                </b-badge>
            </div>
        </div>

        <div class="form-group col-12">
            <label for="teacher">Teacher</label>

            <v-select
                v-model="selectedTeacher"
                label="fullName"
                :options="teachers"
                placeholder="Search..."
                :class="{
                    'is-invalid': hasError('teacherId')
                }"
                @search="onTeacherSearch"
            >
                <template slot="no-options">
                    Start typing to search for a teacher
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('teacherId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="course.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="terminal">Terminal</label>

            <v-select
                v-model="course.terminal"
                label="text"
                :options="paymentMethodOptions"
                :reduce="option => option.value"
                :clearable="false"
                :searchable="false"
                placeholder="Select terminal"
                :class="{ 'is-invalid': hasError('terminal') }"
            />

            <div class="invalid-feedback">
                {{ getError('terminal') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="description">Description</label>
            <textarea
                id="description"
                v-model="course.description"
                type="text"
                class="form-control rtl"
                :class="{
                    'is-invalid': hasError('description')
                }"
                dir="auto"
                rows="4"
                placeholder="Description"
            />
            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="price">Price</label>
            <currency-input
                id="price"
                v-model="course.price"
                class="form-control"
                :class="{
                    'is-invalid': hasError('price')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('price') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="agudaPrice">Price for Aguda members</label>
            <currency-input
                id="agudaPrice"
                v-model="course.agudaPrice"
                class="form-control"
                :class="{
                    'is-invalid': hasError('agudaPrice')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('agudaPrice') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="limit">Limit</label>
            <input
                id="limit"
                v-model.number="course.limit"
                type="number"
                class="form-control"
                :class="{
                    'is-invalid': hasError('limit')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('limit') }}
            </div>
        </div>
        <div v-if="editMode" class="form-group col-12">
            <label for="availableSeats">Available Seats</label>
            <input
                id="availableSeats"
                v-model.number="course.availableSeats"
                type="number"
                class="form-control"
                dir="auto"
                disabled
            />
        </div>

        <div class="form-group col-12">
            <label>Course registration range</label>
            <div class="row">
                <div class="col-6">
                    <input
                        v-model="course.registrationStartsAt"
                        type="date"
                        class="form-control"
                        :disabled="editMode"
                        :class="{
                            'is-invalid': hasError('registrationStartsAt')
                        }"
                    />
                    <small class="pl-1"> Start date </small>

                    <div class="invalid-feedback">
                        {{ getError('registrationStartsAt') }}
                    </div>
                </div>

                <div class="col-6">
                    <input
                        v-model="course.registrationEndsAt"
                        type="date"
                        class="form-control"
                        :disabled="editMode"
                        :class="{
                            'is-invalid': hasError('registrationEndsAt')
                        }"
                    />
                    <small class="pl-1"> End date </small>

                    <div class="invalid-feedback">
                        {{ getError('registrationEndsAt') }}
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group col-12">
            <label for="openingDate">Course opening date</label>
            <input
                id="openingDate"
                v-model="course.openingDate"
                type="datetime-local"
                class="form-control"
                :class="{ 'is-invalid': hasError('openingDate') }"
                dir="auto"
            />

            <div class="invalid-feedback">
                {{ getError('openingDate') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label> Dates of classes </label>

            <div class="marathon-lessons">
                <div
                    v-for="(lesson, index) of course.lessons"
                    :key="index"
                    class="row mb-3 pb-3 align-items-center justify-content-center lesson"
                >
                    <div class="col-5">
                        <label for="location"> Location </label>

                        <input
                            id="location"
                            v-model="lesson.location"
                            type="text"
                            :class="{
                                'is-invalid': hasLessonError('location', index)
                            }"
                            class="form-control"
                            dir="auto"
                        />

                        <div class="invalid-feedback">
                            {{ getError('location', index) }}
                        </div>
                    </div>

                    <div class="col-5 flex-direction-column">
                        <div class="mb-2">
                            <label for="startDate"> Starts at </label>

                            <input
                                id="startDate"
                                v-model="lesson.startsAt"
                                :class="{
                                    'is-invalid': hasLessonError(
                                        'startsAt',
                                        index
                                    )
                                }"
                                type="datetime-local"
                                class="form-control"
                            />

                            <div class="invalid-feedback">
                                {{ getError('startsAt', index) }}
                            </div>
                        </div>

                        <div>
                            <label for="endDate"> Ends at </label>

                            <input
                                id="endDate"
                                v-model="lesson.endsAt"
                                :class="{
                                    'is-invalid': hasLessonError(
                                        'endsAt',
                                        index
                                    )
                                }"
                                type="datetime-local"
                                class="form-control"
                            />

                            <div class="invalid-feedback">
                                {{ getError('endsAt', index) }}
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-2 align-items-center justify-content-center"
                        style="display: flex"
                    >
                        <button
                            v-if="course.lessons.length > 1"
                            class="action-button"
                            @click="handleDeleteDate(index)"
                        >
                            <i class="far fa-trash-alt" />
                        </button>
                    </div>
                </div>
            </div>

            <div>
                <button
                    class="btn btn-success waves-effect waves-light"
                    type="button"
                    @click="handleAddDate"
                >
                    <i class="fas fa-plus" />
                </button>
            </div>
        </div>

        <div class="form-group col-12">
            <label for="paymentMethods">Payment methods</label>

            <b-form-group
                :class="{
                    'is-invalid': hasError('paymentMethods')
                }"
            >
                <b-form-checkbox-group
                    v-model="course.paymentMethods"
                    :options="paymentMethods"
                />
            </b-form-group>

            <div class="invalid-feedback">
                {{ getError('paymentMethods') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PaymentMethodOptions } from '@/enums/paymentMethods';
import CurrencyInput from '@/components/elements/CurrencyInput';

export default {
    components: {
        CurrencyInput
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            course: {},
            teachers: [],
            selectedTeacher: null
        };
    },

    computed: {
        ...mapGetters({
            paymentMethods: 'courses/PAYMENT_METHODS'
        }),

        paymentMethodOptions() {
            return PaymentMethodOptions;
        },

        status() {
            return this.course.status.toUpperCase();
        }
    },

    watch: {
        course() {
            this.$emit('input', this.course);
        },

        selectedTeacher() {
            this.course = {
                ...this.course,
                teacherId: this.selectedTeacher ? this.selectedTeacher.id : null
            };
        }
    },

    async created() {
        this.course = { ...this.value };

        if (this.course.teacherId) {
            this.selectedTeacher = this.course.teacher;
        }

        if (this.course.openingDate) {
            this.course.openingDate = this.$dayjs(
                this.course.openingDate
            ).format('YYYY-MM-DDTHH:mm');
        }

        if (this.course.lessons?.length) {
            this.course.lessons = this.course.lessons.map(lesson => {
                lesson.startsAt = this.$dayjs(lesson.startsAt).format(
                    'YYYY-MM-DDTHH:mm'
                );
                lesson.endsAt = this.$dayjs(lesson.endsAt).format(
                    'YYYY-MM-DDTHH:mm'
                );

                return lesson;
            });

            return;
        }

        this.handleAddDate();
    },

    methods: {
        ...mapActions({
            getTeachers: 'teachers/index'
        }),

        async onTeacherSearch(search, loading) {
            if (search.length) {
                loading(true);

                const { rows: teachers } = await this.getTeachers({
                    search
                });

                this.teachers = teachers;

                loading(false);
            }
        },

        handleDeleteDate(index) {
            if (this.course.lessons.length > 1) {
                this.course.lessons.splice(index, 1);
            }
        },

        handleAddDate() {
            this.course.lessons.push({});
        },

        hasError(key) {
            return (
                this.validation.course[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key, index) {
            const validation = isNaN(index)
                ? this.validation.course
                : this.validation.course.lessons;

            return this.$getValidationErrorMessageHandler.handle(
                validation,
                this.serverErrors,
                key,
                index
            );
        },

        hasLessonError(key, index) {
            return (
                this.validation.course.lessons.$each[index][key].$error ||
                this.serverErrors.find(
                    error => error.param === `lessons[${index}].${key}`
                )
            );
        }
    }
};
</script>
